import React, { Component } from 'react';
import DimensionMemberSelector from '../DimensionMemberSelector';

export default class Share extends Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "baseValueDimension": "",
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dataSource": "",
            "connectionName": "",
            "trend": {
                "name": "Share",
                "type": 4,
                "baseValue": { "caption": "" },
                "isBaseDisplayed": false,
                "useAllOthersCalculation": false,
                "treatNullAsZero": false,
                "slicers": [],
                "selectors": [],
                "active": true,
                "referenceOnly": false,
                "showSlicers": true,
                "userFormat": ""
            },
            "dimensions": [],
            "dataSeriesDimension": "",
            "globals": []
        };
    }
    componentDidMount() {
        let trend = {}
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let dimensions = []
        let dataSeriesDimension = ""
        let connectionName = ""
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.trend !== undefined) { trend = this.props.trend; }
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
        if (this.props.dataSeriesDimension !== undefined) { dataSeriesDimension = this.props.dataSeriesDimension; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.globals !== undefined) { globals =  this.props.globals }

        this.initLoad(this.props.trend, this.props.dimensions);
        let baseValueDimension = this.initLoadGetBaseValueDimension(this.props.trend);
        this.setState({ baseValueDimension, trend, chartId, connectionId, allConnectionIds, dataSource, dimensions, dataSeriesDimension, connectionName, globals });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let trend = {}
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = ""
        let dimensions = []
        let dataSeriesDimension = ""
        let connectionName = ""
        let globals = []

        let previousSlicers = prevProps.trend.slicers;
        let newSlicers = this.props.trend.slicers;

        if (prevProps.chartId !== this.props.chartId) {
            // Read in the props passed in from the parent
            if (this.props.trend !== undefined) { trend = this.props.trend; }
            if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
            if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
            if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
            if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
            if (this.props.dimensions !== undefined) { dimensions = this.props.dimensions; }
            if (this.props.dataSeriesDimension !== undefined) { dataSeriesDimension = this.props.dataSeriesDimension; }
            if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
            if (this.props.globals !== undefined) { globals =  this.props.globals }

            this.initLoad(this.props.trend, this.props.dimensions);
            let baseValueDimension = this.initLoadGetBaseValueDimension(this.props.trend);
            this.setState({ baseValueDimension, trend, chartId, connectionId, allConnectionIds, dataSource, dimensions, dataSeriesDimension, connectionName, globals });
        } else if (previousSlicers.length !== newSlicers.length || this.props.editorUpdates !== prevProps.editorUpdates) {
            this.initLoad(this.props.trend, this.props.dimensions);
            let baseValueDimension = this.initLoadGetBaseValueDimension(this.props.trend);
            this.setState({ baseValueDimension: baseValueDimension, trend: this.props.trend });
        }
    }
    render() {
        let useAllOthersCalculationId = `${this.state.baseValueDimension}-useAllOthersCalculation`;
        let treatNullAsZero = `${this.state.baseValueDimension}-treatNullAsZero`;
        return <div>
            <div style={{ textAlign: "left" }}>Share Set: {this.state.baseValueDimension}</div>
            {this.renderBaseValueTable(this.state.trend, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.dataSeriesDimension, this.state.chartId, this.state.connectionName)}
            <div style={{ textAlign: "left", "margin": "30px 0px" }}>
                <span style={{ "margin": "0px 20px 0px 0px" }}>
                    <input onChange={(e) => { this.handleUseAllOthersCalculationCheckedChanged(e, this.state.trend); }} type="checkbox" checked={this.state.trend.useAllOthersCalculation} id={useAllOthersCalculationId} />
                    <label htmlFor={useAllOthersCalculationId}>Show All Others</label>
                </span>
                <span>
                    <input onChange={(e) => { this.handleTreatNullAsZeroCheckedChanged(e, this.state.trend); }} type="checkbox" checked={this.state.trend.treatNullAsZero} id={treatNullAsZero} />
                    <label htmlFor={treatNullAsZero}>Treat No Data As Zeroes</label>
                </span>
            </div>
            <table style={{ "width": "100%" }}>
                {this.renderSlicerTable(this.state.trend, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.chartId, this.state.connectionName, this.state.globals)}
            </table>
        </div>;
    }
    //#endregion

    //#region Render Methods
    renderSlicerTable = (trend, connectionId, allConnectionIds, dataSource, chartId, connectionName, globals) => {
        let rtnArr = [];

        trend.slicers.forEach((slicer, index) => {
            let selectedItem = { "caption": "", "isSelected": true };
            let items = slicer.items;

            items.forEach(item => {
                if (item.isSelected) { selectedItem = item; }
            });

            rtnArr.push(
                <tbody key={`slicer-${index}`}>
                    <tr>
                        <td style={{ "textAlign": "left", "width": "10%", "minWidth": "125px" }}>{slicer.dimensionAlias}</td>
                        <td style={{ "textAlign": "left", "width": "25%", "minWidth": "330px" }}>{selectedItem.caption}</td>
                        <td style={{ "textAlign": "left" }}>
                            <DimensionMemberSelector
                                multiSelect={false}
                                chartId={chartId}
                                dimensionAlias={slicer.dimensionAlias}
                                connectionId={connectionId}
                                allConnectionIds={allConnectionIds}
                                dataSource={dataSource}
                                selections={slicer.items}
                                connectionName={connectionName}
                                globals={globals}
                                onSelectionChange={(selections, dimensionAlias) => this.updateSlicerData(selections, dimensionAlias)}
                            />
                        </td>
                    </tr>
                </tbody>
            );
        });

        return rtnArr;
    };
    renderBaseValueTable = (trend, connectionId, allConnectionIds, dataSource, dataSeriesDimension, chartId, connectionName) => {
        let baseItemDimension = dataSeriesDimension;
        let baseItemObject = { "caption": "" };
        let baseItemSelectedObject = [];

        if (trend.baseValue !== null) {
            baseItemDimension = trend.baseValue.dimensionAlias;
            baseItemObject = { "caption": trend.baseValue.caption };
            baseItemSelectedObject = [trend.baseValue];
        }

        return <table style={{ "width": "100%" }}>
            <tbody>
                <tr>
                    <td colSpan={3} style={{ "textAlign": "left", "padding": "10px 0px" }}>Base Item:</td>
                </tr>
                <tr>
                    <td style={{ "textAlign": "left", "width": "10%", "minWidth": "125px" }}>{baseItemDimension}</td>
                    <td style={{ "textAlign": "left", "width": "25%", "minWidth": "330px" }}>{baseItemObject["caption"]}</td>
                    <td style={{ "textAlign": "left" }}>
                        <DimensionMemberSelector
                            multiSelect={false}
                            chartId={chartId}
                            dimensionAlias={baseItemDimension}
                            connectionId={connectionId}
                            allConnectionIds={allConnectionIds}
                            dataSource={dataSource}
                            selections={[baseItemSelectedObject]}
                            connectionName={connectionName}
                            onSelectionChange={(selections, dimensionAlias) => this.updateBaseValue(selections)}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    };
    //#endregion

    //#region Data Handlers
    initLoad = (trend, dimensions) => {
        if (trend.slicers.length !== 2) {
            trend.slicers = [];
            dimensions.forEach(d => {
                trend.slicers.push({
                    "dimensionAlias": d.alias,
                    "dimensionSystemName": d.systemName,
                    "typeOfDimension": d.typeOfDimension,
                    "prefix": "",
                    "suffix": "",
                    "items": [],
                    "attributes": []
                });
            });
        }
        // baseValueDimension
    };
    initLoadGetBaseValueDimension = (trend) => {
        let rtnVal = "";

        if (trend.baseValue !== null && trend.baseValue !== undefined) {
            rtnVal = trend.baseValue.dimensionAlias;
        }

        return rtnVal;
    };
    updateBaseValue = (selections) => {
        let trend = this.state.trend;

        if (selections.length > 0) {
            trend.baseValue = selections[0];
        }

        if (this.props.onSelectionChange) { this.props.onSelectionChange(trend); }
        this.setState({ trend });
    };
    updateSlicerData = (selections, dimensionAlias) => {
        let trend = this.state.trend;

        trend.slicers.forEach(s => {
            if (s.dimensionAlias === dimensionAlias) {
                s.items = selections;
            }
        });

        if (this.props.onSelectionChange) { this.props.onSelectionChange(trend); }
        this.setState({ trend });
    };
    //#endregion

    //#region Event Handlers
    handleUseAllOthersCalculationCheckedChanged = (e, trend) => {
        trend.useAllOthersCalculation = e.target.checked;
        this.setState({ trend });
    };
    handleTreatNullAsZeroCheckedChanged = (e, trend) => {
        trend.treatNullAsZero = e.target.checked;
        this.setState({ trend });
    };
    //#endregion
}